var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconAlert = function SvgIconAlert(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Layer 1",
    viewBox: "0 0 100 100",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_alert_svg2__a",
    x1: 25.25,
    x2: 98.12,
    y1: 106.1,
    y2: 26.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#a80096"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_alert_svg2__a",
    id: "icon_alert_svg2__b",
    x1: 10.73,
    x2: 83.59,
    y1: 92.76,
    y2: 13.43
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_alert_svg2__a",
    id: "icon_alert_svg2__c",
    x1: -13.67,
    x2: 59.19,
    y1: 70.35,
    y2: -8.98
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_alert_svg2__a",
    id: "icon_alert_svg2__d",
    x1: 35.13,
    x2: 107.99,
    y1: 115.17,
    y2: 35.84
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_alert_svg2__a",
    id: "icon_alert_svg2__e",
    x1: -11.68,
    x2: 61.18,
    y1: 72.17,
    y2: -7.16
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_alert_svg2__a",
    id: "icon_alert_svg2__f",
    x1: -22.3,
    x2: 50.56,
    y1: 62.42,
    y2: -16.91
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_alert_svg2__a",
    id: "icon_alert_svg2__g",
    x1: 12.13,
    x2: 84.99,
    y1: 94.05,
    y2: 14.72
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_alert_svg2__a",
    id: "icon_alert_svg2__h",
    x1: 18.78,
    x2: 91.65,
    y1: 100.16,
    y2: 20.83
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M91.89 96.15H81.84V86.1c0-1.06-.86-1.92-1.92-1.92h-4.06V50c0-14.26-11.6-25.86-25.86-25.86S24.14 35.74 24.14 50v34.18h-4.06c-1.06 0-1.92.86-1.92 1.92v10.05H8.11a1.92 1.92 0 0 0 0 3.84H91.9a1.92 1.92 0 0 0 0-3.84ZM27.98 50c0-12.14 9.88-22.02 22.02-22.02S72.02 37.86 72.02 50v34.18H27.98zM22 88.03h56v8.12H22z",
    style: {
      fill: "url(#icon_alert_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 57.91c1.06 0 1.92-.86 1.92-1.92V44.02a1.92 1.92 0 0 0-3.84 0v11.97c0 1.06.86 1.92 1.92 1.92",
    style: {
      fill: "url(#icon_alert_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.03 50c0-1.06-.86-1.92-1.92-1.92H1.92a1.92 1.92 0 0 0 0 3.84H8.1c1.06 0 1.92-.86 1.92-1.92Z",
    style: {
      fill: "url(#icon_alert_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.08 48.08H91.9a1.92 1.92 0 0 0 0 3.84h6.18a1.92 1.92 0 0 0 0-3.84",
    style: {
      fill: "url(#icon_alert_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 10.03c1.06 0 1.92-.86 1.92-1.92V1.92a1.92 1.92 0 0 0-3.84 0V8.1c0 1.06.86 1.92 1.92 1.92Z",
    style: {
      fill: "url(#icon_alert_svg2__e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.02 21.74c.38.38.87.56 1.36.56s.98-.19 1.36-.56c.75-.75.75-1.97 0-2.72l-4.23-4.23c-.75-.75-1.97-.75-2.72 0s-.75 1.97 0 2.72z",
    style: {
      fill: "url(#icon_alert_svg2__f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.62 22.3c.49 0 .98-.19 1.36-.56l4.23-4.23c.75-.75.75-1.97 0-2.72s-1.97-.75-2.72 0l-4.23 4.23c-.75.75-.75 1.97 0 2.72.38.38.87.56 1.36.56",
    style: {
      fill: "url(#icon_alert_svg2__g)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 64.24c-1.07 0-1.93.87-1.93 1.93s.87 1.93 1.93 1.93 1.93-.87 1.93-1.93-.87-1.93-1.93-1.93",
    style: {
      fill: "url(#icon_alert_svg2__h)"
    }
  }));
};
export default SvgIconAlert;